import {
  getFCCFlowName,
  setCookie,
  fccConstantValues,
  checkFccLabel,
  crossSiteCheckUrl,
  setSession,
  getCookie,
  getSession,
  isHomeInternetBroadBandFlow,
} from '../../common/Helpers';

export const lowerCase = (data) => {
  if (data) {
    return data.toLowerCase();
  }
  return data;
};

export const enableBroadBandFacts = () => {
  if (checkFccLabel()) {
    return true;
  }
  window.location.href = crossSiteCheckUrl(window?.location?.origin);
};

export const setCookieDetails = (category = '', subCategory = '', site = '') => {
  if (site) {
    setCookie('site', site);
  }
  setCookie('category', category);
  setCookie('subCategory', subCategory);
};

export const ConstantText = {
  invalidZipError:
    "The Zip Code you've entered is outside of our newtork coverage area. In order to establish service with Verizon, your billing and shipping addresses, and your primary place of use, must be within the areas served by the network Verizon owns and operates.",
  header: 'Enter your address to get broadband fact labels.',
  inputLabel: 'Street address',
  helperText: 'Type your address (without unit #) and select the one closest to your own.',
  unlimited: {
    address_header: 'To get the most accurate information about wireless pricing, and coverage near you, please enter your location below.',
    broadBand_header: {
      all: 'Unlimited mobile plans - broadband fact labels',
    },
    url: 'mobile-postpaid',
    filter: {
      all: 'Smartphone',
    },
  },
  connected_devices: {
    address_header: 'To get the most accurate information about wireless pricing, and coverage near you, please enter your location below.',
    broadBand_header: {
      tablet: 'Tablet data plans- broadband fact labels',
      smartwatch: 'Smartwatch data plans- broadband fact labels',
      mobilehotspot: 'Mobile hotspot data plans- broadband fact labels',
      laptop: 'Laptop data plans- broadband fact labels',
      connectedcar: 'Connected car data plans- broadband fact labels',
      security: 'Security data plans- broadband fact labels',
    },
    url: 'connected-devices',
    filter: {
      Tablet: 'Tablet',
      Smartwatch: 'Smartwatch',
      Mobilehotspot: 'Hotspot',
      Laptop: 'Laptop',
      ConnectedCar: 'Connected Car',
      Security: 'Camera',
    },
  },
  '55+': {
    address_header: '',
    broadBand_header: {
      all: 'Unlimited mobile plans - broadband fact labels',
    },
    filter: {
      all: '55+',
    },
  },
  prepaid: {
    address_header: 'To get the most accurate information about wireless pricing, and coverage near you, please enter your location below.',
    broadBand_header: {
      phoneplan: 'Prepaid phone plans - broadband fact labels',
      dataplan: 'Prepaid data plans - broadband fact labels',
      smartwatchplan: 'Prepaid smartwatch plans - broadband fact labels',
    },
    url: {
      phoneplan: 'mobile-prepaid',
      dataplan: 'prepaid-data',
      smartwatchplan: 'connected-devices-prepaid',
    },
    payloadrequest: {
      phoneplan: {
        deviceId: 'dev21410824',
        skuId: 'sku6004570',
      },
      dataplan: {
        deviceId: 'dev21410938',
        skuId: 'sku6007433',
      },
      smartwatchplan: {
        deviceId: 'dev21411041',
        skuId: 'sku6004549',
      },
    },
  },
};

export const getURLEndPoint = () => {
  const flowType = getFCCFlowName();

  if (flowType?.flowName) {
    const endpoint = ConstantText?.[lowerCase(flowType?.flowName)]?.url;
    if (lowerCase(flowType?.flowName) === lowerCase(fccConstantValues.cookieValue.Prepaid)) {
      return endpoint?.[lowerCase(flowType?.subFlowName)];
    }
    return endpoint;
  }
  return '';
};

export const getAddressHeader = () => {
  const flowType = getFCCFlowName();
  if (flowType?.flowName) return ConstantText?.[lowerCase(flowType?.flowName)]?.address_header;
  return '';
};

export const getFilter = () => {
  const flowType = getFCCFlowName();
  if (flowType?.flowName) {
    const value = ConstantText?.[lowerCase(flowType?.flowName)]?.filter;
    if (value) {
      if (flowType?.subFlowName) {
        return value?.[flowType?.subFlowName];
      }
      return value?.all;
    }
  }
};

export const getBroadBandHeader = () => {
  const flowType = getFCCFlowName();
  if (flowType?.flowName) {
    const value = ConstantText?.[lowerCase(flowType?.flowName)]?.broadBand_header;
    if (flowType?.subFlowName) {
      return value?.[lowerCase(flowType?.subFlowName)];
    }
    return value?.all;
  }
};

export const filteredValue = (json) => {
  // debugger;
  const getFilterValue = getFilter();
  if (json?.plans) {
    // eslint-disable-next-line no-param-reassign
    json.plans = json?.plans?.filter((item) => item?.planSubCategory === getFilterValue);
  }
  return json;
};

export const isPrepaidNRFlow = () => {
  const flowType = getFCCFlowName();

  if (
    lowerCase(flowType?.flowName) === lowerCase(fccConstantValues.cookieValue.Prepaid) &&
    lowerCase(flowType?.site) === lowerCase(fccConstantValues.NationalRetailerFlow)
  ) {
    return true;
  }
  return false;
};

export const showSurcharges = () => {
  const { flowName } = getFCCFlowName();
  if (flowName === fccConstantValues?.flowName?.Prepaid) {
    return false;
  }
  return true;
};

export const getPayloadProspect = () => {
  const flowType = getFCCFlowName();
  if (flowType?.flowName) {
    const value = ConstantText?.[lowerCase(flowType?.flowName)]?.payloadrequest;
    if (flowType?.subFlowName) {
      return value?.[lowerCase(flowType?.subFlowName)];
    }
    return { deviceId: '', skuId: '' };
  }
};

export const showAddress = () => {
  const { flowName, site } = getFCCFlowName();
  if (flowName === fccConstantValues?.flowName?.Prepaid && site === fccConstantValues?.NationalRetailerFlow) {
    return false;
  }
  return true;
};

export const filterBasedOnPlanId = (response, planId) => {
  // debugger;
  if (response?.plans) {
    response.plans = response?.plans?.filter((item) => item?.planCode === planId);
  }
  return response;
};

export const filteredValueFor55 = (response) => {
  // debugger;
  if (response?.plans) {
    response.plans = response?.plans?.filter((item) => item?.planSubCategory === '55+');
  }
  return response;
};

export const setSelectedAddress = (json) => {
  if (json) {
    const addressSelected = {
      zip: json?.zip || '',
      muni: json?.muni || '',
      dispstr: json?.dispstr || '',
      state: json?.state || '',
      entireStreetAddress: json?.entireStreetAddress || '',
      addressLine2: json?.parserAddressLine2 || '',
    };
    setSession('SELECTED_ADDRESS', JSON.stringify(addressSelected));
    setCookie('SELECTED_ADDRESS', JSON.stringify(addressSelected));
  }
};

export const getSelectedAddress = () => {
  const session = getLocalStorageParsedItem('SELECTED_ADDRESS');
  return session;
};

export const getCurrentFCCDate = () =>{
  const {date, month, year} = getFormatedDate(new Date())
  return (`${month}/${date}/${year}`)
}

export const getFormatedDate = (dt) => {
  // var dt = new Date();
  const year = dt.getFullYear();
  const month = (dt.getMonth() + 1).toString().padStart(2, "0");
  const date = dt.getDate().toString().padStart(2, "0");
  return ({date,month,year})
}

const getLocalStorageParsedItem = (key) => {
  if (key) {
    const sessionValue = getSession(key) || JSON.stringify(getCookie(key));
    if (sessionValue) {
      return JSON.parse(sessionValue);
    }
  }
  return '';
};

export const setSessionDetails = () => {
  const address = getSelectedAddress();
  const isHomeInternetFlow = getSession('fcc');
  setCookie('SELECTED_ADDRESS', JSON.stringify(address));
  setCookie('LQResponse', JSON.stringify(getSession('LQResponse')));
  setCookie('fcc', isHomeInternetFlow);
};

export const restoreSessionDetails = () => {
  const addressSelected = JSON.parse(getCookie('SELECTED_ADDRESS'));
  const LQAddress = JSON.parse(getCookie('LQResponse'));
  const isHomeInternetFlow = getCookie('fcc');
  if (addressSelected) {
    setSession('SELECTED_ADDRESS', JSON.stringify(addressSelected));
    setCookie('SELECTED_ADDRESS', JSON.stringify(addressSelected));
  }
  if (LQAddress) {
    setSession('LQResponse', JSON.stringify(LQAddress));
  }
  if (isHomeInternetFlow) {
    setSession('fcc', isHomeInternetFlow);
  }
};

export const getFCCCookies = () => {
  const site = getCookie('site');
  const category = getCookie('category');
  const subcategory = getCookie('subCategory');

  const cookieObj = { site, category, subcategory };

  return cookieObj;
};

// on language transition set cookie values
export const appendQueryValues = () => {
  let queryValue = '';
  const { site, category, subcategory } = getFCCCookies();
  const { search } = window.location;

  if (site) {
    if (search?.includes('planid')) {
      queryValue = `&site=${site}`;
    } else {
      queryValue = `?site=${site}`;
    }
  }
  if (category) {
    queryValue = `${queryValue}&category=${category}`;
  }
  if (subcategory) {
    queryValue = `${queryValue}&subCategory=${subcategory}`;
  }
  if (isHomeInternetBroadBandFlow()) {
    queryValue = `${queryValue}&fcc=true`;
  }

  if (getSession('SELECTED_ADDRESS') && getSession('SELECTED_ADDRESS') !== '') {
    queryValue = `${queryValue}&addressObj=${getSession('SELECTED_ADDRESS')}`;
  }

  return queryValue;
};

export const setCookieFromURL = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const site = params.get('site');
  const category = params.get('category');
  const subCategory = params.get('subCategory');
  const address = params.get('addressObj');
  const fcc = params.get('fcc');

  if (fcc) {
    setCookie('fcc', fcc);
    setSession('fcc', fcc);
  }
  if (site && category) {
    setCookie('site', site);
    setCookie('category', category);
  }
  if (subCategory) {
    setCookie('subCategory', subCategory);
  }
  if (address) {
    setSession('SELECTED_ADDRESS', address);
  }
};
